import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: ({ variant }) => ({
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    ...(variant && {
      left: '50%',
      transform: 'translate(-50%, 0%)',
      bottom: '50px',
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(8),
    }),
    ...(!variant && {
      width: '80%',
      padding: '0',
    }),
    margin: '0 auto',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      bottom: '20px',
      width: variant ? '100%' : '90%',
    },
  }),
  background: ({ variant }) => ({
    width: '100%',
    backgroundColor: variant ? 'rgba(0, 17, 35, 0.5)' : theme.palette.background.default,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: variant ? '2rem' : '1rem 2rem',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }),
  header: ({ variant }) => ({
    color: variant ? theme.palette.opaque.white : theme.palette.opaque.blue,
    ...(variant && {
      marginBottom: theme.spacing(1),
    }),
    '&.primary': {
      [theme.breakpoints.down('sm')]: {
        ...theme.typography.h6,
      },
    },
  }),
  subtitle: ({ variant }) => ({
    ...(variant && {
      color: theme.palette.opaque.white,
    }),
  }),
  flexLeft: ({ variant }) => ({
    display: 'flex',
    marginTop: 'auto',
    marginBottom: 'auto',
    flexDirection: variant ? 'column' : 'row',
    ...(!variant && {
      gap: '1rem',
    }),
    ...(variant && {
      width: '60%',
    }),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      ...(variant && {
        width: '100%',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(2),
      }),
      ...(!variant && {
        alignItems: 'center',
      }),
    },
  }),
  link: ({ variant }) => ({
    padding: '0',
    marginLeft: theme.spacing(2),
    color: variant ? theme.palette.opaque.white : theme.palette.blue.main,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
    '&:hover': {
      ...(variant && {
        color: theme.palette.opaque.white,
      }),
    },
    '&>span>svg': {
      color: variant ? theme.palette.opaque.white : theme.palette.blue.main,
    },
  }),
}))

export default useStyles
